import { render, staticRenderFns } from "./DesktopLayout.vue?vue&type=template&id=40d13830&"
import script from "./DesktopLayout.vue?vue&type=script&lang=js&"
export * from "./DesktopLayout.vue?vue&type=script&lang=js&"
import style0 from "./DesktopLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports